import { Component, Input, OnInit } from '@angular/core';
import { BaseNavigationService } from '@wz-services';

@Component({
  selector: 'wz-page-header',
  templateUrl: './tunnelsante-page-header.component.html',
  styleUrls: ['./tunnelsante-page-header.component.scss'],
  standalone: false,
})
export class TunnelSantePageHeaderComponent implements OnInit {
  @Input() backLink!: string;
  constructor(private navService: BaseNavigationService) {}

  ngOnInit() {}

  navigateBack() {
    this.navService.navigate([this.backLink]);
  }
}
